var map = {
  "./cs.json": [
    "GoT",
    [
      "kn"
    ]
  ],
  "./en.json": [
    "tki",
    [
      751
    ]
  ],
  "./pl.json": [
    "hc9",
    [
      "rb"
    ]
  ],
  "./ru.json": [
    "NtY",
    [
      "jc"
    ]
  ],
  "./tr.json": [
    "l8h",
    [
      "7j"
    ]
  ],
  "./ja.json": [
    "nMy",
    [
      "hh"
    ]
  ],
  "./zh.json": [
    "o1Z",
    [
      "61z"
    ]
  ],
  "./pt-br.json": [
    "fap",
    [
      "1j"
    ]
  ],
  "./de.json": [
    "nIM",
    [
      "1t"
    ]
  ],
  "./es.json": [
    "Std",
    [
      "0c6"
    ]
  ],
  "./fr.json": [
    "owv",
    [
      "2j"
    ]
  ],
  "./it.json": [
    "qW",
    [
      "k5"
    ]
  ],
  "./ko.json": [
    "eU",
    [
      "c8"
    ]
  ],
  "./pt.json": [
    "sv",
    [
      "mic"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "va";
module.exports = __rspack_async_context;
